module.exports = __webpack_public_path__ + "img/shuoming2026.57aa19d9.png";